import { customLog } from 'helpers/customLog';

import { ctService, sentryService } from '@/services/index';

import { productMappingBasedOnCustomerId } from './productMapper';

export const fetchCTCustomerId = (customerType: string, source: string) =>
  ctService.getTempCustomerId(customerType, source);

export const fetchCustomerOrder = async (id: string) => {
  return await ctService.getCustomerOrder(id);
};

export const priceOrderProductDetails = (orderTotals: any) => {
  let subTotalPriceItem: any = null;
  let otTotalNoOtcItem: any = null;
  let totalPriceItem: any = null;
  if (orderTotals.length) {
    const productPriceMap = new Map(orderTotals.map((p: any) => [p.className, p]));

    subTotalPriceItem = productPriceMap.get('ot_subtotal');
    otTotalNoOtcItem = productPriceMap.get('ot_total_no_otc');
    totalPriceItem = productPriceMap.get('ot_total');
  }
  customLog('priceOrderProductDetails', subTotalPriceItem, otTotalNoOtcItem, totalPriceItem);
  return {
    subTotalPriceItem,
    otTotalNoOtcItem,
    totalPriceItem,
  };
};

export const extractCtPrices = (ctResponse: any) => {
  const subTotalPrice = ctResponse?.ongoingTotalPrice;
  const otTotalNoOtcPrice = ctResponse?.recurringTotalPrice;
  const totalPricePrice = ctResponse?.cartTotalPrice;
  const totalPrice = otTotalNoOtcPrice !== 0 ? otTotalNoOtcPrice : totalPricePrice;
  return { subTotalPrice, otTotalNoOtcPrice, totalPrice };
};

export const extractKkPrices = (orderTotals: any) => {
  const priceItem = priceOrderProductDetails(orderTotals);
  const subTotalPrice = priceItem?.subTotalPriceItem?.value ?? 0.0;
  const otTotalNoOtcPrice = priceItem?.otTotalNoOtcItem?.value ?? 0.0;
  const totalPricePrice = priceItem?.totalPriceItem?.value ?? 0.0;
  const totalPrice = otTotalNoOtcPrice !== 0 ? otTotalNoOtcPrice : totalPricePrice;
  return { subTotalPrice, otTotalNoOtcPrice, totalPrice };
};

export const updateCustomerOrder = async (
  customerId: string,
  customerType: string,
  products: any[],
  couponCode: any[],
  CTItemsPayload?: any[],
  voucherDetails?: any,
  removeVoucherFlag?: boolean
) => {
  try {
    const codes = (CTItemsPayload ?? []).map(change => ({
      code: change.code,
      quantity: change.quantity,
      action: change.action,
      occurrenceNumber: change.occurrenceNumber,
    }));

    customLog('updateCustomerOrder (CT) - codes:', codes);
    const removeVoucher = sessionStorage.getItem('removeVoucher') === 'true';
    let ctResult: any = null;
    try {
      ctResult = await ctService.updateOrder(
        customerId,
        codes,
        'web',
        customerType,
        voucherDetails?.voucher?.Campaigns,
        voucherDetails?.voucher?.ProductType,
        removeVoucherFlag ?? removeVoucher
      );
      removeVoucherFlag !== false && sessionStorage.removeItem('removeVoucher');
    } catch (ctError) {
      sentryService.captureException(new Error(`CT updateOrder failed: ${ctError}`));
    }
    const { subTotalPrice, otTotalNoOtcPrice, totalPrice } = extractCtPrices(ctResult);
    return {
      subTotalPrice,
      totalPrice,
      otTotalNoOtcPrice,
      orderProducts: ctResult?.items,
      campaigns: ctResult?.campaigns ?? [],
    };
  } catch (error) {
    sentryService.captureException(error);
    customLog('Error in updateCustomerOrder:', error);
    throw error;
  }
};

export const fetchOrderBasedOnCustomerId = async (
  customerId: string,
  productList: any[],
  category?: string
) => {
  try {
    const response = await fetchCustomerOrder(customerId);
    if (response) {
      const productDetails = await productMappingBasedOnCustomerId(response, productList, category);
      customLog('productMappingBasedOnCustomerId (CT)', productDetails);
      return productDetails;
    }
  } catch (error) {
    sentryService.captureException(error);
    throw error;
  }
};
